import { Group, Highlight } from "@mantine/core";
import { IconBuildings } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StackOrModal } from "../../../../../mantine/components/StackOrModal/StackOrModal";
import { MantineCellIcon } from "../../../../../mantine/mrt/components/cell/MantineCellIcon/MantineCellIcon";
import type { PPAContract } from "../../PPAContractPage.types";

export function getServiceRecipientsColumn(
  contracts: Array<PPAContract>
): MRT_ColumnDef<PPAContract> {
  const usedServiceRecipientNames = contracts
    .flatMap((contract) => contract.service_recipients)
    .map((recipient) => recipient.name);
  const sortedAndUniqueCustomers = Array.from(
    new Set(usedServiceRecipientNames)
  ).sort();

  return {
    accessorKey: "service_recipients",
    header: "Empfänger",
    filterFn: (row, _columnId, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }

      const recipientNames = row.original.service_recipients.map((r) => r.name);

      return recipientNames.some((name) => filterValue.includes(name));
    },
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: sortedAndUniqueCustomers
    },
    size: 210,
    Cell: ({ row, table }) => {
      const search = table.getState().globalFilter ?? "";

      return (
        <StackOrModal
          elementText="Empfänger"
          numElements={row.original.service_recipients.length}
        >
          {row.original.service_recipients.map((recipient) => (
            <Group key={recipient.id} wrap="nowrap">
              <MantineCellIcon IconComponent={IconBuildings} />
              <Highlight highlight={search}>{recipient.name}</Highlight>
            </Group>
          ))}
        </StackOrModal>
      );
    }
  };
}
